import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { fetch as fetch } from '../../actions'
import { useSavePost } from './../../components/Hooks/Conexao';
import { LoadingScreen, Tag, SubTitulo } from '../../components/Diversos';
import { Button, Tabs, Tooltip, Drawer, Input, Select, Modal } from 'antd';
import Mensagens from '../../components/Mensagens';

function Func(props) {
   
    const [disponiveis, setDisponiveis] = useState(props.dados.disponiveis);
    const [marcadas, setMarcadas] = useState(props.dados.marcadas);
    const [saveData, setSaveData] = useState(null);

    const [save, saving] = useSavePost(props.fetch, '/cliente/save', { modelo: 'cli-tags',  id: props.id,  dados: { tags: saveData } },
    (d) => {
      Mensagens.showSucesso('Dados gravados com sucesso!');
   });

   const preSave = () => {
        const aux = marcadas.map(x => x.id);
        setSaveData(aux.join(';'));
   }

   useEffect(() => {
        console.log('tags', saveData);
        if(saveData != null){
            save();
        }
   }, [saveData])

    const add = (t, inx) => {
        let dispAux = [...disponiveis];
        dispAux.splice(inx, 1);

        setDisponiveis(dispAux);
        setMarcadas([...marcadas, t]);
    }

    const remove = (t, inx) => {
        let marcaAux = [...marcadas];
        marcaAux.splice(inx, 1);

        setMarcadas(marcaAux);
        setDisponiveis([...disponiveis, t]);
    }

    return   (<><div style={{minHeight: 250, display: 'flex'}}>
       <div style={{padding:10, backgroundColor: '#eee', borderRadius: 3, flex: 1, marginRight:5}}>
           {disponiveis.map((t, inx) => <Tag key={t.id} style={{marginRight: 4, marginBottom:4}} className="divTagHover" onClick={() => add(t, inx)}>{t.nome}</Tag>)}
       </div>
       <div style={{padding:10, backgroundColor: '#eee', borderRadius: 3, flex: 1, marginLeft: 5}}>
           {marcadas.map((t, inx) => <Tag key={t.id} style={{marginRight: 4, marginBottom:4}} className="divTagHover" onClick={() => remove(t, inx)}>{t.nome}</Tag>)}
       </div>
    </div>
    <div style={{textAlign:'right', marginTop:5}}><Button type="primary" disabled={saving} onClick={preSave}>Gravar Alterações</Button></div>
    </>)
}
 
export default connect(null, { fetch })(Func);
